export default __webpack_public_path__ + "static/media/Button-Games.f99146ca.svg";